import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'app/pokemons',
		component: Base,
		children: [
			{
				path: '',
				name: 'PokemonsList',
				component: List,
				meta: {
					path: '/app/pokemons',
					pai: 'App',
					title: 'App - Pokémons',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Pokémons',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'PokemonsNovo',
				component: Form,
				meta: {
					path: '/app/pokemons',
					pai: 'App',
					title: 'App - Pokémons - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Pokémons',
						class: '',
						active: false,
						url: '/site/pokemons'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'PokemonsEditar',
				component: Form,
				meta: {
					path: '/app/pokemons',
					pai: 'App',
					title: 'App - Pokémons - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Pokémons',
						class: '',
						active: false,
						url: '/app/pokemons'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]